export default __webpack_public_path__ + "static/media/setpoint-logo.4b85faee.png";